import axios from 'axios';
import { serverConfig } from './server-config';
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);
export const ClientPreLoginService = {
  requestDemo: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/client/pre-login/request-demo`;

    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error requesting demo:", error);
        throw error;
      });
  },

  letsTalkContactForm: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/client/pre-login/lets-talk`;

    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error requesting demo:", error);
        throw error;
      });
  },

  ClientRegistration: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/client/pre-login/register`;

    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error during registering:", error);
        throw error;
      });
  },

  RegisterForm: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/client/pre-login/show-interest`;

    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error during registering:", error);
        throw error;
      });
  },

  subscribe: async (emailId) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/client/pre-login/subscribe?emailId=${emailId}`;

    return axios.post(url, {}, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error subscribing:", error);
        throw error;
      });
  },
};
